export default {
   data() {
		return {
			videoDataObj: {
				src: '',
				type: '',
				height: '',
				width: ''
			},
			resolution: {
				max: (window.screen.availWidth > window.screen.availHeight) ? window.screen.availWidth : window.screen.availHeight
			},
		}
   },

   methods: {
		checkResolution(vimeoFiles) {
			let lastVal = 0
			let rightObj = {};

			for (let urlData of vimeoFiles) {
				let videoResMaxVal = urlData.height > urlData.width ? urlData.height : urlData.width

				if(Math.abs(this.resolution.max - videoResMaxVal) <= Math.abs(this.resolution.max - lastVal)) {
					rightObj = urlData
					// console.log(rightObj)
					// console.log('vid_res: ' + this.resolution.max + ' video_max: ' +  videoResMaxVal + ' last: ' + lastVal + ' two_values: ' + (this.resolution.max - videoResMaxVal) + ' - ' + (this.resolution.max - lastVal))
					lastVal = videoResMaxVal
				}
			}

			this.videoDataObj.src = rightObj.link
			this.videoDataObj.type = rightObj.type
			this.videoDataObj.height = rightObj.height
			this.videoDataObj.width = rightObj.width
		},
   }
}
